import { TIntlDictionary } from 'types/i18n';
import {
  EmailFormValues,
  EmailFormViolation,
  TEmailFormValidation__depricated,
} from 'types/emailFormTypes';
import { stringIsEmpty, stringIsEmail } from 'utils/stringUtils';
import { stringOrVoid } from 'utils/validation';

export const validateEmailFormValues__depricated = (i18n: TIntlDictionary) => (
  values: EmailFormValues
): TEmailFormValidation__depricated => {
  return {
    email:
      stringOrVoid(stringIsEmpty(values.email), i18n.inputValidationRequired) ||
      stringOrVoid(!stringIsEmail(values.email), i18n.inputValidationEmail),
  };
};

export const validateEmailFormValues = (
  values: EmailFormValues
): EmailFormViolation[] => {
  const violations: EmailFormViolation[] = [];

  if (stringIsEmpty(values.email)) {
    violations.push({
      name: 'EmailMissed',
    });
  }

  if (!stringIsEmail(values.email)) {
    violations.push({
      name: 'EmailMalformed',
    });
  }

  return violations;
};
